import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { getOutgoers, Handle, Position } from "reactflow";
import { nodeEventWidth } from "../flowSettings";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import NodeBranchCreator from "../components/NodeBranchCreator";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { IconPlayerPlay, IconPlayerPlayFilled } from "@tabler/icons-react";
import NodePlus from "./NodePlus";

const StartNode = ({ data, id, xPos, yPos }) => {
  const lang = useLanguage((s) => s.language);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);

  const outgoers = useMemo(() => {
    let n = nodes.find((x) => x.id === id);
    if (n)
      return getOutgoers(n, nodes, edges).filter((x) => x.type !== "trail");
    return [];
  }, [id, nodes, edges]);

  return (
    <Stack
      pos={"relative"}
      h={window.innerWidth < 1600 ? 104 : 116}
      align="center"
      justify="center"
    >
      <Handle
        type="source"
        position={Position.Right}
        style={{ visibility: "hidden" }}
      />
      <Group justify="center" h={"100%"} align="center">
        <ThemeIcon variant="subtle" size={64}>
          <IconPlayerPlayFilled size={48} />
        </ThemeIcon>
      </Group>

      <NodePlus
        isRight
        id={id}
        data={data}
        xPos={xPos}
        yPos={yPos}
        isBranch={outgoers.length > 0}
        isEvent
        inStart
      />
    </Stack>
  );
};

export default StartNode;
